import React from 'react';

import IconSwatchRequest from 'components/icons/iconSwatchRequest';

const SwatchRequestIcon = ({ color }) => (
  <IconSwatchRequest width="36" height="36" color={color} />
);

export default SwatchRequestIcon;
